import { SpinnerContainer, SpinnerIcon } from "./style";

export const LoadingSpinner = () => (
    <SpinnerContainer>
        <SpinnerIcon />
        {/* <LoadingText>Carregando</LoadingText> */}
    </SpinnerContainer>
);